import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {ListItemMeta as RmwcListItemMeta} from '@rmwc/list'
import '@rmwc/list/styles'

export const listItemMetaPrimary2Styles = css`
  color: var(--mdc-theme-on-primary2);
`

const StyledRmwcListItemMeta = styled(RmwcListItemMeta)`
  .mdc-theme--on-primary2 &&& {
    ${listItemMetaPrimary2Styles}
  }
`

const DrawerListItemMeta = ({children, ...otherProps}) => <StyledRmwcListItemMeta {...otherProps}>{children}</StyledRmwcListItemMeta>

DrawerListItemMeta.propTypes = {
  children: PropTypes.any
}

export {DrawerListItemMeta}
